// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TV AI Widget — streamlined banner matching main dashboard style */
.tv-ai-widget {
  background: var(--bg-card, rgba(15, 20, 35, 0.85));
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));
  border-radius: var(--radius-md, 12px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* ── Header ── */
.tv-ai-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-sm, 8px) var(--spacing-md, 12px);
  border-bottom: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));
  flex-shrink: 0;
}

.tv-ai-header-left {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm, 8px);
}

.tv-ai-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.tv-ai-icon svg {
  width: 16px;
  height: 16px;
}

.tv-ai-icon.budget-warn {
  background: linear-gradient(135deg, #f59e0b, #ef4444);
  animation: tvBudgetPulse 2s ease-in-out infinite;
}

@keyframes tvBudgetPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

.tv-ai-title-group {
  display: flex;
  flex-direction: column;
}

.tv-ai-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary, #ffffff);
  line-height: 1.2;
}

.tv-ai-subtitle {
  font-size: 0.65rem;
  color: var(--text-secondary, rgba(255, 255, 255, 0.6));
  display: flex;
  align-items: center;
  gap: 4px;
}

.tv-ai-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}

.tv-ai-status-dot.healthy {
  background: #22c55e;
  box-shadow: 0 0 4px rgba(34, 197, 94, 0.5);
}

.tv-ai-status-dot.fallback {
  background: #f59e0b;
  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);
}

.tv-ai-status-dot.degraded {
  background: #f59e0b;
  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);
  animation: tvDegradedDotPulse 1.5s ease-in-out infinite;
}

@keyframes tvDegradedDotPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.tv-ai-status-dot.warning {
  background: #f59e0b;
  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);
}

.tv-ai-status-dot.error,
.tv-ai-status-dot.checking {
  background: #64748b;
}

/* Header right: alert badge + loading dots */
.tv-ai-header-right {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm, 8px);
}

.tv-ai-alert-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 600;
}

.tv-ai-alert-badge.has-alerts {
  background: rgba(239, 68, 68, 0.15);
  color: #fca5a5;
}

.tv-ai-alert-badge.no-alerts {
  background: rgba(34, 197, 94, 0.1);
  color: #86efac;
}

.tv-ai-loading-indicator {
  display: flex;
  gap: 3px;
}

.tv-ai-loading-indicator span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #6366f1;
  animation: tvAiDotPulse 1.4s ease-in-out infinite;
}

.tv-ai-loading-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}

.tv-ai-loading-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes tvAiDotPulse {
  0%, 80%, 100% { opacity: 0.3; transform: scale(0.8); }
  40% { opacity: 1; transform: scale(1); }
}

/* ── Body ── */
.tv-ai-body {
  flex: 1 1;
  padding: var(--spacing-sm, 8px) var(--spacing-md, 12px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm, 8px);
  min-height: 0;
}

.tv-ai-body::-webkit-scrollbar {
  width: 3px;
}

.tv-ai-body::-webkit-scrollbar-track {
  background: transparent;
}

.tv-ai-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

/* Loading */
.tv-ai-loading {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm, 8px);
  color: var(--text-secondary, rgba(255, 255, 255, 0.6));
  font-size: 0.8rem;
  padding: var(--spacing-sm, 8px) 0;
}

.tv-ai-loading-dots {
  display: flex;
  gap: 4px;
}

.tv-ai-loading-dots span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #6366f1;
  animation: tvAiDotPulse 1.4s ease-in-out infinite;
}

.tv-ai-loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.tv-ai-loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

/* Error */
.tv-ai-error {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm, 8px);
  padding: var(--spacing-sm, 8px) var(--spacing-md, 12px);
  background: rgba(239, 68, 68, 0.08);
  border-radius: var(--radius-sm, 8px);
  color: #fca5a5;
  font-size: 0.8rem;
}

.tv-ai-error-icon {
  flex-shrink: 0;
}

/* ── Briefing ── */
.tv-ai-briefing {
  background: rgba(99, 102, 241, 0.06);
  border: 1px solid rgba(99, 102, 241, 0.15);
  border-radius: var(--radius-sm, 8px);
  padding: var(--spacing-sm, 8px) var(--spacing-md, 12px);
}

.tv-ai-briefing-label {
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6366f1;
  margin-bottom: 4px;
}

.tv-ai-briefing-text {
  font-size: 0.8rem;
  line-height: 1.5;
  color: var(--text-primary, #ffffff);
  margin: 0;
}

/* ── Alerts ── */
.tv-ai-alerts {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tv-ai-alerts-label {
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary, rgba(255, 255, 255, 0.6));
  margin-bottom: 2px;
}

.tv-ai-alert-item {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-sm, 8px);
  padding: var(--spacing-xs, 4px) var(--spacing-sm, 8px);
  border-radius: var(--radius-sm, 8px);
  font-size: 0.8rem;
  line-height: 1.4;
}

.tv-ai-alert-item.critical {
  background: rgba(239, 68, 68, 0.08);
  border-left: 3px solid #ef4444;
  color: #fca5a5;
}

.tv-ai-alert-item.warning {
  background: rgba(245, 158, 11, 0.08);
  border-left: 3px solid #f59e0b;
  color: #fcd34d;
}

.tv-ai-alert-item.info {
  background: rgba(59, 130, 246, 0.08);
  border-left: 3px solid #3b82f6;
  color: #93c5fd;
}

.tv-ai-alert-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.tv-ai-alert-content {
  flex: 1 1;
}

.tv-ai-alert-title {
  font-weight: 600;
  margin-bottom: 2px;
}

.tv-ai-alert-message {
  opacity: 0.85;
  font-size: 0.75rem;
}

.tv-ai-no-alerts {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm, 8px);
  padding: var(--spacing-xs, 4px) var(--spacing-sm, 8px);
  background: rgba(34, 197, 94, 0.08);
  border-radius: var(--radius-sm, 8px);
  color: #86efac;
  font-size: 0.8rem;
}

/* ── Recommendations ── */
.tv-ai-recommendations-label {
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary, rgba(255, 255, 255, 0.6));
  margin-bottom: var(--spacing-xs, 4px);
}

.tv-ai-rec-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tv-ai-rec-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  background: rgba(99, 102, 241, 0.08);
  border: 1px solid rgba(99, 102, 241, 0.15);
  border-radius: 20px;
  font-size: 0.75rem;
  color: var(--text-primary, #ffffff);
}

.tv-ai-rec-icon {
  font-size: 0.8rem;
}

/* ── Footer ── */
.tv-ai-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: var(--spacing-xs, 4px);
  border-top: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));
  font-size: 0.6rem;
  color: var(--text-secondary, rgba(255, 255, 255, 0.4));
  opacity: 0.7;
}

/* Fallback error notice */
.tv-ai-fallback-error {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 4px 8px;
  background: rgba(245, 158, 11, 0.08);
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: var(--radius-sm, 8px);
  font-size: 0.65rem;
  color: #fcd34d;
  line-height: 1.4;
}

.tv-ai-fallback-error-icon {
  flex-shrink: 0;
}

.tv-ai-fallback-error-text {
  word-break: break-word;
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/components/TV/TVAIWidget.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;EACE,kDAAkD;EAClD,gEAAgE;EAChE,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uDAAuD;EACvD,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,gDAAgD;AAClD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,uDAAuD;AACzD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB,YAAY,EAAE,qBAAqB,EAAE;EACrD,MAAM,UAAU,EAAE,mBAAmB,EAAE;AACzC;;AAEA,eAAe;AACf;EACE,SAAO;EACP,uDAAuD;EACvD,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sDAAsD;EACtD,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uDAAuD;EACvD,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,sDAAsD;EACtD,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sDAAsD;EACtD,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;EACd,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;EACnC,oEAAoE;EACpE,iBAAiB;EACjB,sDAAsD;EACtD,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd","sourcesContent":["/* TV AI Widget — streamlined banner matching main dashboard style */\n.tv-ai-widget {\n  background: var(--bg-card, rgba(15, 20, 35, 0.85));\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));\n  border-radius: var(--radius-md, 12px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* ── Header ── */\n.tv-ai-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-sm, 8px) var(--spacing-md, 12px);\n  border-bottom: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));\n  flex-shrink: 0;\n}\n\n.tv-ai-header-left {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm, 8px);\n}\n\n.tv-ai-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  flex-shrink: 0;\n}\n\n.tv-ai-icon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.tv-ai-icon.budget-warn {\n  background: linear-gradient(135deg, #f59e0b, #ef4444);\n  animation: tvBudgetPulse 2s ease-in-out infinite;\n}\n\n@keyframes tvBudgetPulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.6; }\n}\n\n.tv-ai-title-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.tv-ai-title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-primary, #ffffff);\n  line-height: 1.2;\n}\n\n.tv-ai-subtitle {\n  font-size: 0.65rem;\n  color: var(--text-secondary, rgba(255, 255, 255, 0.6));\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.tv-ai-status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.tv-ai-status-dot.healthy {\n  background: #22c55e;\n  box-shadow: 0 0 4px rgba(34, 197, 94, 0.5);\n}\n\n.tv-ai-status-dot.fallback {\n  background: #f59e0b;\n  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);\n}\n\n.tv-ai-status-dot.degraded {\n  background: #f59e0b;\n  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);\n  animation: tvDegradedDotPulse 1.5s ease-in-out infinite;\n}\n\n@keyframes tvDegradedDotPulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n\n.tv-ai-status-dot.warning {\n  background: #f59e0b;\n  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);\n}\n\n.tv-ai-status-dot.error,\n.tv-ai-status-dot.checking {\n  background: #64748b;\n}\n\n/* Header right: alert badge + loading dots */\n.tv-ai-header-right {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm, 8px);\n}\n\n.tv-ai-alert-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n.tv-ai-alert-badge.has-alerts {\n  background: rgba(239, 68, 68, 0.15);\n  color: #fca5a5;\n}\n\n.tv-ai-alert-badge.no-alerts {\n  background: rgba(34, 197, 94, 0.1);\n  color: #86efac;\n}\n\n.tv-ai-loading-indicator {\n  display: flex;\n  gap: 3px;\n}\n\n.tv-ai-loading-indicator span {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: #6366f1;\n  animation: tvAiDotPulse 1.4s ease-in-out infinite;\n}\n\n.tv-ai-loading-indicator span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.tv-ai-loading-indicator span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes tvAiDotPulse {\n  0%, 80%, 100% { opacity: 0.3; transform: scale(0.8); }\n  40% { opacity: 1; transform: scale(1); }\n}\n\n/* ── Body ── */\n.tv-ai-body {\n  flex: 1;\n  padding: var(--spacing-sm, 8px) var(--spacing-md, 12px);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm, 8px);\n  min-height: 0;\n}\n\n.tv-ai-body::-webkit-scrollbar {\n  width: 3px;\n}\n\n.tv-ai-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.tv-ai-body::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 2px;\n}\n\n/* Loading */\n.tv-ai-loading {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm, 8px);\n  color: var(--text-secondary, rgba(255, 255, 255, 0.6));\n  font-size: 0.8rem;\n  padding: var(--spacing-sm, 8px) 0;\n}\n\n.tv-ai-loading-dots {\n  display: flex;\n  gap: 4px;\n}\n\n.tv-ai-loading-dots span {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #6366f1;\n  animation: tvAiDotPulse 1.4s ease-in-out infinite;\n}\n\n.tv-ai-loading-dots span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.tv-ai-loading-dots span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n/* Error */\n.tv-ai-error {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm, 8px);\n  padding: var(--spacing-sm, 8px) var(--spacing-md, 12px);\n  background: rgba(239, 68, 68, 0.08);\n  border-radius: var(--radius-sm, 8px);\n  color: #fca5a5;\n  font-size: 0.8rem;\n}\n\n.tv-ai-error-icon {\n  flex-shrink: 0;\n}\n\n/* ── Briefing ── */\n.tv-ai-briefing {\n  background: rgba(99, 102, 241, 0.06);\n  border: 1px solid rgba(99, 102, 241, 0.15);\n  border-radius: var(--radius-sm, 8px);\n  padding: var(--spacing-sm, 8px) var(--spacing-md, 12px);\n}\n\n.tv-ai-briefing-label {\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #6366f1;\n  margin-bottom: 4px;\n}\n\n.tv-ai-briefing-text {\n  font-size: 0.8rem;\n  line-height: 1.5;\n  color: var(--text-primary, #ffffff);\n  margin: 0;\n}\n\n/* ── Alerts ── */\n.tv-ai-alerts {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.tv-ai-alerts-label {\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary, rgba(255, 255, 255, 0.6));\n  margin-bottom: 2px;\n}\n\n.tv-ai-alert-item {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-sm, 8px);\n  padding: var(--spacing-xs, 4px) var(--spacing-sm, 8px);\n  border-radius: var(--radius-sm, 8px);\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n.tv-ai-alert-item.critical {\n  background: rgba(239, 68, 68, 0.08);\n  border-left: 3px solid #ef4444;\n  color: #fca5a5;\n}\n\n.tv-ai-alert-item.warning {\n  background: rgba(245, 158, 11, 0.08);\n  border-left: 3px solid #f59e0b;\n  color: #fcd34d;\n}\n\n.tv-ai-alert-item.info {\n  background: rgba(59, 130, 246, 0.08);\n  border-left: 3px solid #3b82f6;\n  color: #93c5fd;\n}\n\n.tv-ai-alert-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.tv-ai-alert-content {\n  flex: 1;\n}\n\n.tv-ai-alert-title {\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n\n.tv-ai-alert-message {\n  opacity: 0.85;\n  font-size: 0.75rem;\n}\n\n.tv-ai-no-alerts {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm, 8px);\n  padding: var(--spacing-xs, 4px) var(--spacing-sm, 8px);\n  background: rgba(34, 197, 94, 0.08);\n  border-radius: var(--radius-sm, 8px);\n  color: #86efac;\n  font-size: 0.8rem;\n}\n\n/* ── Recommendations ── */\n.tv-ai-recommendations-label {\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary, rgba(255, 255, 255, 0.6));\n  margin-bottom: var(--spacing-xs, 4px);\n}\n\n.tv-ai-rec-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.tv-ai-rec-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 10px;\n  background: rgba(99, 102, 241, 0.08);\n  border: 1px solid rgba(99, 102, 241, 0.15);\n  border-radius: 20px;\n  font-size: 0.75rem;\n  color: var(--text-primary, #ffffff);\n}\n\n.tv-ai-rec-icon {\n  font-size: 0.8rem;\n}\n\n/* ── Footer ── */\n.tv-ai-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: var(--spacing-xs, 4px);\n  border-top: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));\n  font-size: 0.6rem;\n  color: var(--text-secondary, rgba(255, 255, 255, 0.4));\n  opacity: 0.7;\n}\n\n/* Fallback error notice */\n.tv-ai-fallback-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 4px 8px;\n  background: rgba(245, 158, 11, 0.08);\n  border: 1px solid rgba(245, 158, 11, 0.2);\n  border-radius: var(--radius-sm, 8px);\n  font-size: 0.65rem;\n  color: #fcd34d;\n  line-height: 1.4;\n}\n\n.tv-ai-fallback-error-icon {\n  flex-shrink: 0;\n}\n\n.tv-ai-fallback-error-text {\n  word-break: break-word;\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
